import { z } from "zod";

/** Email addresses are stored lowercase so that lookups and comparisons are exact. */
export const emailSchema = z.email().max(254).toLowerCase();

/** ISO 8601 UTC timestamp, as produced by `Date.prototype.toISOString`. */
export const isoTimeSchema = z.iso.datetime();

/** A value that an input can hold after it is filled. */
export const inputValueSchema = z.union([z.string(), z.number(), z.boolean()]);
export type InputValue = z.infer<typeof inputValueSchema>;

export const inputValuesSchema = z.record(z.string(), inputValueSchema);
export type InputValues = z.infer<typeof inputValuesSchema>;

/** Hard caps on text that goes to a model, a webhook, or a table item. */
export const LIMITS = {
  messageText: 8_000,
  /** A written input that a member edited before approval. */
  editedText: 8_000,
  textPreview: 300,
  reason: 200,
  instructions: 4_000,
  tenantName: 80,
  subject: 500,
  responseSnippet: 500,
  examples: 20,
  /** Messages in one bulk override. */
  bulkOverride: 100,
  historyStored: 10,
  historyRouted: 3,
} as const;
